/**
 *
 * LoadingIndicator
 *
 */

import React from 'react';

// import ProdigalVoiceLogo from 'images/prodigalvoice-logo.png';
import LoadingIcon from 'assets/icons/loading.gif';
import { Text } from 'components/common';
import './style.css';
// import styled from 'styled-components';

/**
 * Simple Loading Indicator, use classes.
 * */
function LoadingIndicator({
  text,
  disableImage = false,
  background = true,
  ...rest
}: any) {
  return (
    <div style={rest.style} className="main-async-loader">
      {/* {!disableImage && <img src={ProdigalVoiceLogo} alt="Loading..." />} */}
      <div className="child-loader-container">
        <Text text={text || ''} />
        <div
          className={`loading-icon ${background ? ' loading-background' : ''}`}
        >
          <img src={LoadingIcon} alt="" />
        </div>
      </div>
    </div>
  );
}

export default LoadingIndicator;
